<template>
	<view class="list">
		<view class="list-item" v-for="(item, index) in list" :key="index" @click="selectRow(item)">
			<view class="list-item-left">
				<view class="list-item-a">
					<text>{{item.name}}</text>
					<text>{{item.phone}}</text>
					<text v-if="item.isDefault === 1">默认</text>
				</view>
				<view class="list-item-b">{{item.areaDetail}}{{item.addr}}</view>
			</view>
			<image src="/static/icon/address_ic_edit@2x.png" mode="widthFix" @click.stop="edit(item)"></image>
		</view>
		<view class="button" @click="add">
			<image src="/static/images/icon_add_dz@2x.png" mode="widthFix"></image>
			<text>添加收货地址</text>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				type: null
			};
		},
		onShow() {
			this.getAddr()
		},
		onLoad(option) {
			if (option.type) {
				this.type = option.type
			}
		},
		methods: {
			selectRow(item) {
				if (this.type == 1) {
					uni.$emit('updateAddress', item)
					uni.navigateBack({ delta: 1 });
				}
			},
			getAddr() {
				this.$u.api.findListAddr()
					.then(res => {
						if (res.code === 200) {
							this.list = res.data
						}
					})
			},
			add() {
				uni.navigateTo({
					url: '/pages/new-address/new-address'
				})
			},
			edit(item) {
				uni.setStorageSync('addr', item);
				uni.navigateTo({
					url: '/pages/new-address/new-address'
				})
			}
		}
	}
</script>
<style>
	page {
		background-color: #FAFAFA;
	}
</style>
<style lang="scss" scoped>
	.list {
		width: 100%;
		padding: 20rpx 30rpx;
		box-sizing: border-box;
		.button {
			width: calc(100% - 60rpx);
			height: 88rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			background: linear-gradient( 270deg, #66F8E4 0%, #15B9F7 100%), #10B2FA;
			border-radius: 44rpx;
			position: fixed;
			left: 30rpx;
			bottom: calc(20rpx + env(safe-area-inset-bottom));
			image {
				width: 28rpx;
				height: 28rpx;
			}
			text {
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
			}
		}
		.list-item {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 20rpx;
			margin-bottom: 20rpx;
			display: flex;
			align-items: center;
			&:last-child {
				margin: 0 !important;
			}
			.list-item-left {
				flex: 1;
				display: flex;
				flex-direction: column;
				.list-item-a {
					width: 100%;
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 28rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 28rpx;
							color: #666666;
							margin-left: 20rpx;
						}
						&:nth-child(3) {
							width: 68rpx;
							height: 42rpx;
							line-height: 42rpx;
							text-align: center;
							border-radius: 8rpx;
							border: 1rpx solid #004096;
							font-weight: 400;
							font-size: 24rpx;
							color: #004096;
							margin-left: 20rpx;
						}
					}
				}
				.list-item-b {
					width: 100%;
					font-weight: 400;
					font-size: 28rpx;
					color: #222222;
					margin: 24rpx 0;
				}
			}
			image {
				flex-shrink: 0;
				width: 40rpx;
				height: 40rpx;
				margin-left: 30rpx;
			}
		}
	}
</style>
